// ai/* 페이지 번역
const ai = {
  aiAnalysis: {
    newChat: '새 대화',
    send: '전송',
    file: {
      excel: 'Excel 파일',
      csv: 'CSV 파일',
      pdf: 'PDF 파일',
      file: '파일',
      rows: '({n}건)',
      download: '다운로드',
      ready: '데이터 준비됨',
    },
    title: 'AI 분석',
    welcome: '안녕하세요! AI 분석 도우미입니다. 사출 설비 데이터, 생산 현황, 알람 분석 등에 대해 질문해주세요.',
    welcomeMatch: '안녕하세요! AI 분석 도우미입니다',
    noResponse: '응답을 받지 못했습니다.',
    errorMessage: '죄송합니다. 메시지를 처리하는 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
    assistant: 'AI 어시스턴트',
    user: '사용자',
    suggestionsTitle: '추천 질문',
    placeholder: '질문을 입력하세요... (Shift+Enter로 줄바꿈)',
    suggestions: {
      qualityDefectTrend: '최근 불량률 추이를 선그래프로 보여줘',
      qualityTopAlarmEquip: '오늘 품질 알람이 가장 많이 발생한 설비는?',
      qualityTempAnalysis: '사출 1호기의 최근 온도 변화에 대해서 분석해줘',
      qualityDefectByEquip: '최근 7일간 설비별 불량 발생 현황을 막대그래프로 보여줘',
      productionRunningEquip: '현재 가동 중인 설비 현황은?',
      productionTopOutput: '오늘 생산량이 가장 많은 설비는?',
      productionTrend: '최근 7일간 생산량 추이를 선그래프로 보여줘',
      productionUtilizationCompare: '설비별 가동률을 비교해줘',
      maintenanceTopAlarm: '오늘 알람이 가장 많이 발생한 설비는?',
      maintenanceAlarmTrend: '최근 7일간 설비별 알람 발생 추이를 보여줘',
      maintenanceCycleTimeAnalysis: '사출 1호기의 최근 사이클 타임 변화를 분석해줘',
      maintenanceIdleEquip: '현재 비가동 설비 현황은?',
      defaultRunningEquip: '현재 가동 중인 설비 현황은?',
      defaultTopAlarm: '오늘 알람이 가장 많이 발생한 설비는?',
      defaultTrend: '최근 7일간 생산량 추이를 선그래프로 보여줘',
      defaultShotTempAnalysis: '사출 1호기에 최근 샷 온도 변화에 대해서 분석해줘',
    },
  },
  aiManage: {
    addBtn: '모델 연결 추가',
    tabs: { connections: '모델 연결', calls: '호출 이력' },
    provider: { OPENAI_COMPATIBLE: 'OpenAI 호환 (DGX·LM Studio 등)', ANTHROPIC: 'Anthropic Claude' },
    feature: {
      CHAT_SQL: 'AI 분석 · 질문 해석·SQL 생성 (도구 호출)',
      CHAT_ANSWER: 'AI 분석 · 답변 작성',
      ANALYSIS: 'AI 분석 · 데이터 분석 에이전트',
      VISUALIZATION: 'AI 분석 · 차트 생성',
      REPORT: '보고서 · 일/주/월 보고서·알람 분석·개선 제안',
    },
    featureShort: { CHAT_SQL: 'SQL 생성', CHAT_ANSWER: '답변 작성', ANALYSIS: '분석', VISUALIZATION: '차트', REPORT: '보고서' },
    connections: {
      title: '모델 연결',
      help: '챗봇·보고서가 쓰는 LLM 연결입니다. 키는 암호화해 저장되고 화면에 다시 표시되지 않습니다. 키를 비우면 서버 환경변수(OPENAI_API_KEY / ANTHROPIC_API_KEY)를 씁니다.',
      empty: '등록된 모델 연결이 없습니다.',
    },
    card: {
      active: '사용', inactive: '중지', keySaved: '키 저장됨', keyEnv: '환경변수 키', keyNone: '키 없음',
      workspace: '워크스페이스', testFailed: '연결 실패 — 아래 오류 원문을 확인하세요', errorDetail: '오류 원문 보기',
      noFeatures: '배정된 기능 없음', test: '테스트', testing: '테스트 중…', edit: '수정', delete: '삭제',
      deleteBlocked: '배정된 기능이 있어 삭제할 수 없습니다. 먼저 배정을 바꾸세요.',
    },
    assign: {
      title: '기능별 모델 배정',
      help: '기능마다 어느 연결을 쓸지 고릅니다. 바꾸면 다음 호출부터 바로 적용됩니다. 미배정이면 첫 번째 사용 중 연결을 씁니다.',
      feature: '기능', connection: '모델 연결', updated: '변경', none: '(미배정 · 첫 연결 사용)',
    },
    form: {
      addTitle: '모델 연결 추가', editTitle: '모델 연결 수정',
      connKey: '연결 키', name: '이름', provider: '제공자', apiBase: 'API 주소', modelName: '모델',
      loadModels: '모델 목록 불러오기', modelsLoaded: '모델 {n}개를 불러왔습니다. 입력란에서 고를 수 있습니다.', noModels: '모델 목록이 비어 있습니다.',
      apiKey: 'API 키', apiKeyKeep: '비우면 저장된 키를 유지합니다', apiKeyEnv: '비우면 서버 환경변수 키를 씁니다', clearKey: '저장된 키 삭제',
      workspaceId: '워크스페이스 ID (선택)', workspaceHint: '워크스페이스에 묶이지 않은 키(sk-ant-usr…)를 쓸 때만 입력합니다. Claude Console 의 워크스페이스 ID(wrkspc_…)',
      timeoutMs: '타임아웃(ms)', maxTokens: '최대 토큰', temperature: 'temperature', effort: 'effort (사고 깊이)',
      sortOrder: '정렬', isActive: '사용 여부', description: '설명', default: '기본값',
      anthropicHint: 'Claude 5.x 는 temperature 를 받지 않고 effort 로 사고 깊이를 조절합니다. 채팅은 low 가 빠릅니다.',
      required: '연결 키·이름·모델은 필수입니다.',
    },
    calls: {
      title: '최근 호출 100건', todayCalls: '오늘 호출', todayTokens: '오늘 토큰', monthCalls: '이번 달 호출', monthTokens: '이번 달 토큰',
      monthFailures: '이번 달 실패', avgLatency: '평균 응답', byConnection: '이번 달 연결별',
      time: '시각', feature: '기능', connection: '연결', model: '모델', tenant: '사업장', inTokens: '입력 토큰', outTokens: '출력 토큰',
      latency: '응답(ms)', result: '결과', failed: '실패', empty: '호출 이력이 없습니다.',
    },
    msg: { saved: '저장했습니다.', deleted: '삭제했습니다.', assigned: '배정을 바꿨습니다.', confirmDelete: "'{name}' 연결을 삭제할까요?" },
  },
};

export default ai;
